import styled from 'styled-components';

export const InternalTable = styled.div`
  border-radius: 0.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  color: 'red';
  width: 100%;
  gap: 0.5rem;
  padding: 0.3rem;
  background-color: ${(props) => props?.color || 'transparent'};
  height: 100%;
  &:hover {
    opacity: 0.8;
  }
`;

export const ProfileAgentCell = styled.img`
  border-radius: 50%;
  width: 32px;
  height: 32px;
  box-shadow: 0 0 0 1px #00000010;
`;
